import Cookies from 'js-cookie'

const TokenKey = 'aixue_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 30 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setValue(key,value) {
  return Cookies.set(key, value)
}

export function getValue(key) {
  return Cookies.get(key)
}